import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LOGIN_OR_SIGNUP_SOCIAL_FIRST = defineFcm('login_or_signup_social_first')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: { enabled: { type: 'boolean', optional: true } },
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Login or Signup',
		description:
			'Enables the login_social_buttons_first_experiment (social login buttons above the email form on /login_or_join).',
		template: { enabled: true },
	});
